import React from 'react';
import { useFormik } from 'formik';

import { Grid } from '@mui/material';
import { postDataToTheServer } from '../../../../helpers/api';
import AppURL from '../../../../constants/AppURL';
import { ToastSuccess, ToastWarning } from '../../../../constants/Toast';
import SecHeading from '../../../../constants/SecHeading';
import Container from '../../../../constants/Container';
import InputTextBox from '../../../../constants/InputTextBox';
import { EndBaseLine } from '../../../../constants/AppSpace';
import { Button } from '../../../../constants/Button';
import { MeterTypeOptions, TapSizeOptions, YesNoOptions } from '../../../../constants/Options';
import { TapSize } from '../../../../helpers/models/Models';
import SelectionBox from '../../../../constants/SelectionBox';

interface FiscalAddFormViewProps {
    handleFormSuccess: () => void;
    tap_list: {
        results: TapSize[];
        previous: string | null;
        next: string | null;
    } | null;
    tap_loading: boolean;
}
const TariffParameterCreateView: React.FC<FiscalAddFormViewProps> = ({tap_list, tap_loading, handleFormSuccess }) => {
    const initialValues = {
        tap_type: "",
        tap_size: "",
        unit_from: "",
        unit_to: "",
        unit_amt: "",
        per_unit: "",
        remarks: "",
    };
    const { values, errors, touched, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        enableReinitialize: true,
        onSubmit: async (values, action) => {
            const formData = new FormData();
            formData.append("tap_type", values.tap_type);
            formData.append("tap_size", values.tap_size);
            formData.append("unit_from", values.unit_from);
            formData.append("unit_to", values.unit_to);
            formData.append("unit_amt", values.unit_amt);
            formData.append("remarks", values.remarks);
            formData.append("per_unit", values.per_unit === "1" ? "1" : "0");
            try {
                await postDataToTheServer(AppURL.AccountURL + 'account/unit/rate/create/list/view/', formData).then((res) => {
                    if (res?.status === 201) {
                        handleFormSuccess();
                        ToastSuccess({ message: res?.message });
                        action.resetForm();
                    } else if (res?.status === 400) {
                        ToastWarning({ message: res?.message });
                    }
                    else {
                        ToastWarning({ message: "Some Issue" });
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },
    });
    const tapSizeOptions = TapSizeOptions(tap_list?.results);
    return (
        <Container padding={true}>
            <form onSubmit={handleSubmit}>
                <SecHeading type='add' label='Tariff Parameter Add' />
                <Grid container columnSpacing={3} rowSpacing={0.8}>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <SelectionBox
                            label='Tap Type'
                            options={MeterTypeOptions}
                            handleChange={(name, selectedOption: any) => {
                                setFieldValue(name, selectedOption.value);
                            }
                            }
                            required={false}
                            placeholder='Select tap type'
                            name='tap_type'
                            handleBlur={() => {
                                handleBlur({ target: { name: 'tap_type' } });
                            }}
                            value={values.tap_type}
                            touched={touched.tap_type}
                            errors={errors.tap_type}
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <SelectionBox
                            label='Tap Size'
                            options={tapSizeOptions}
                            handleChange={(name, selectedOption: any) => {
                                setFieldValue(name, selectedOption.value);
                            }
                            }
                            isLoading={tap_loading}
                            required={false}
                            placeholder='Select tap size'
                            name='tap_size'
                            handleBlur={() => {
                                handleBlur({ target: { name: 'tap_size' } });
                            }}
                            value={values.tap_size}
                            touched={touched.tap_size}
                            errors={errors.tap_size}
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <InputTextBox
                            type='nnumber'
                            name='unit_from'
                            label='Unit From'
                            handleChange={handleChange}
                            value={values.unit_from}
                            error={errors.unit_from}
                            handleBlur={handleBlur}
                            touched={touched.unit_from}
                            required={true}
                            placeholder='0'
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <InputTextBox
                            type='nnumber'
                            name='unit_to'
                            label='Unit To'
                            handleChange={handleChange}
                            value={values.unit_to}
                            error={errors.unit_to}
                            handleBlur={handleBlur}
                            touched={touched.unit_to}
                            required={true}
                            placeholder='0'
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <InputTextBox
                            type='number'
                            name='unit_amt'
                            label='Unit Amt'
                            handleChange={handleChange}
                            value={values.unit_amt}
                            error={errors.unit_amt}
                            handleBlur={handleBlur}
                            touched={touched.unit_amt}
                            required={true}
                            placeholder='0.00'
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <SelectionBox
                            label='Per Unit Amount'
                            options={YesNoOptions}
                            handleChange={(name, selectedOption: any) => {
                                setFieldValue(name, selectedOption.value);
                            }
                            }
                            value={values.per_unit}
                            required={true}
                            placeholder='Select Per unit'
                            name='per_unit'
                            handleBlur={() => {
                                handleBlur({ target: { name: 'per_unit' } });
                            }}
                            touched={touched.per_unit}
                            errors={errors.per_unit}
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <EndBaseLine top={18}>
                            <Button btn_type='save' type='submit' el='button' />
                        </EndBaseLine>
                    </Grid>
                </Grid>
            </form>

        </Container>
    )
}

export default TariffParameterCreateView
